import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ClipboardModule } from "ngx-clipboard";
import { Ng2FileInputModule } from "ng2-file-input";

import { MaterialAppModule } from "../../../ngmaterial.module";

import * as saml from ".";

import { CommonModule } from "../../../common/common.module";

@NgModule({
	imports: [
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		BrowserModule,
		CommonModule,
		ClipboardModule,
		MaterialAppModule,
		Ng2FileInputModule.forRoot()
	],
	declarations: [
		saml.SamlUploadComponent,
		saml.SamlDownloadComponent,
		saml.SamlSummaryComponent,
		saml.SamlAttributesComponent,
		saml.SamlSelectIdpComponent
	],
	providers: [
		saml.SamlWizardService
	]
})
export class SamlWizardModule { }
